export default "__VITE_ASSET__CNYiekzz__"